import React, { useState } from 'react';
import { KeywordDomainRankGq } from '../../../../../../graphql/projects/models/KeywordDomainRankGq';
import { ProjectGq } from '../../../../../../graphql/projects/models/ProjectGq';
import { ProjectKeywordGq } from '../../../../../../graphql/projects/models/ProjectKeywordGq';
import { SerpStatusGq } from '../../../../../../graphql/projects/models/SerpStatusGq';
import { CurrentUserGq } from '../../../../../../graphql/users/models/CurrentUserGq';
import SerpResultsPopover from '../../../../../../pages/DataManagementPage/components/Dialogs/SerpResultsPopover';
import VoxelLoadingSpinner from '../../../../../voxel/Animation/VoxelLoadingSpinner';
import VoxelDataTableCell from '../../../../../voxel/DataTable/VoxelDataTableCell';
import AddRankDataButton from './AddRankDataButton';
import { getRankColor } from './rankColorScheme';

export interface TableCellRankProps {
  rankColor: boolean;
  keyword: ProjectKeywordGq;
  project: ProjectGq;
  domainId: number;
  keywordDomainRank?: KeywordDomainRankGq;
  borderLeft?: boolean;
  serpStatus?: SerpStatusGq;
  user?: CurrentUserGq;
  reload?: () => Promise<any>;
}

const TableCellRank: React.FC<TableCellRankProps> = ({
  rankColor,
  keyword,
  project,
  keywordDomainRank,
  borderLeft,
  serpStatus,
  user,
  reload,
}) => {
  const [loading, setLoading] = useState(false);

  if (!keyword.serpResultTime)
    return (
      <VoxelDataTableCell align={'right'} className={`${borderLeft && 'border-l'} `}>
        <div className="w-full flex flex-row justify-end">
          {(serpStatus === SerpStatusGq.PROCESSING || loading) && (
            <span className="w-8 flex flex-row justify-center items-center">
              <VoxelLoadingSpinner />
            </span>
          )}
          {!(serpStatus === SerpStatusGq.PROCESSING || loading) && (
            <AddRankDataButton
              project={project}
              user={user}
              keyword={keyword}
              reload={reload}
              setLoading={setLoading}
            />
          )}
        </div>
      </VoxelDataTableCell>
    );

  return (
    <VoxelDataTableCell
      align={'right'}
      className={`${borderLeft && 'border-l'} ${rankColor ? getRankColor(keywordDomainRank?.rank) : ''
        }`}
    >
      <div
        className="flex flex-row justify-end"
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <SerpResultsPopover keyword={keyword} rank={keywordDomainRank?.rank} project={project} rankColor={rankColor} />
      </div>
    </VoxelDataTableCell>
  );
};

export default TableCellRank;
